import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect, useState } from 'react';
import { S_TextInput } from '../../../../../design/inputs/textInput/S_TextInput';
import { drawingScreenDisables, keyboardShortcutsServiceInstance } from '../../../../services/keyboardShortcuts.service';
import { ITextAnswerProps } from '../../question.model';

export const TextAnswer = observer((props: ITextAnswerProps): ReactElement => {
  const [answer, setAnswer] = useState<string>(props.answer);
  const { t } = useTranslator();

  useEffect(() => {
    setAnswer(props.answer);
  }, [props.answer]);

  const handleFocus = (): void => {
    keyboardShortcutsServiceInstance.disableShortcuts(drawingScreenDisables);
  };

  const handleBlur = (): void => {
    keyboardShortcutsServiceInstance.enableShortcuts(drawingScreenDisables);
    props.onAnswered(answer);
  };

  const handleAnswer = (answer: string): void => {
    setAnswer(answer);
  };

  return (
    <S_TextInput
      tabIndex={1}
      className={props.className}
      value={answer}
      type={'textarea'}
      onChange={handleAnswer}
      maxLength={1000}
      placeholder={t('open_answer_placeholder')}
      disabled={props.disabled}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );
});
